import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isHomePage = location.pathname === '/';

  return (
    <nav 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHomePage
          ? 'bg-white/95 backdrop-blur-md shadow-lg' 
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center cursor-pointer">
            <img 
              src="https://static.readdy.ai/image/939ff17c9dd5dcb6a914aa959dc9f824/56c2956145aae033251ab37a1ea52e57.png" 
              alt="DFF Distribution" 
              className="h-12"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8">
            <Link 
              to="/" 
              className={`whitespace-nowrap text-sm font-medium transition-colors cursor-pointer ${
                isScrolled || !isHomePage
                  ? 'text-slate-700 hover:text-slate-900'
                  : 'text-white hover:text-slate-200'
              }`}
            >
              Home
            </Link>
            <Link 
              to="/about" 
              className={`whitespace-nowrap text-sm font-medium transition-colors cursor-pointer ${
                isScrolled || !isHomePage
                  ? 'text-slate-700 hover:text-slate-900'
                  : 'text-white hover:text-slate-200'
              }`}
            >
              About
            </Link>
            <Link 
              to="/industries" 
              className={`whitespace-nowrap text-sm font-medium transition-colors cursor-pointer ${
                isScrolled || !isHomePage
                  ? 'text-slate-700 hover:text-slate-900'
                  : 'text-white hover:text-slate-200'
              }`}
            >
              Industries
            </Link>
            <Link 
              to="/vendors" 
              className={`whitespace-nowrap text-sm font-medium transition-colors cursor-pointer ${
                isScrolled || !isHomePage
                  ? 'text-slate-700 hover:text-slate-900'
                  : 'text-white hover:text-slate-200'
              }`}
            >
              Vendors
            </Link>
            <Link 
              to="/vendor-registration" 
              className={`whitespace-nowrap text-sm font-medium transition-colors cursor-pointer ${
                isScrolled || !isHomePage
                  ? 'text-slate-700 hover:text-slate-900'
                  : 'text-white hover:text-slate-200'
              }`}
            >
              Become a Vendor
            </Link>
            <Link 
              to="/contact" 
              className={`whitespace-nowrap text-sm font-medium transition-colors cursor-pointer ${
                isScrolled || !isHomePage
                  ? 'text-slate-700 hover:text-slate-900'
                  : 'text-white hover:text-slate-200'
              }`}
            >
              Contact
            </Link>
            <Link 
              to="/login" 
              className="whitespace-nowrap px-6 py-2.5 bg-slate-900 text-white text-sm font-semibold rounded-lg hover:bg-slate-800 hover:shadow-lg transition-all duration-300 cursor-pointer flex items-center gap-2"
            >
              <i className="ri-flag-line"></i>
              Customer Login
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
              isScrolled || !isHomePage ? 'text-slate-900' : 'text-white'
            }`}
          >
            <i className={`text-2xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 border-t border-slate-200">
            <div className="flex flex-col space-y-4 pt-4">
              <Link 
                to="/" 
                onClick={() => setIsMobileMenuOpen(false)}
                className="whitespace-nowrap text-slate-700 hover:text-slate-900 text-sm font-medium cursor-pointer"
              >
                Home
              </Link>
              <Link 
                to="/about" 
                onClick={() => setIsMobileMenuOpen(false)}
                className="whitespace-nowrap text-slate-700 hover:text-slate-900 text-sm font-medium cursor-pointer"
              >
                About
              </Link>
              <Link 
                to="/industries" 
                onClick={() => setIsMobileMenuOpen(false)}
                className="whitespace-nowrap text-slate-700 hover:text-slate-900 text-sm font-medium cursor-pointer"
              >
                Industries
              </Link>
              <Link 
                to="/vendors" 
                onClick={() => setIsMobileMenuOpen(false)}
                className="whitespace-nowrap text-slate-700 hover:text-slate-900 text-sm font-medium cursor-pointer"
              >
                Vendors
              </Link>
              <Link 
                to="/vendor-registration" 
                onClick={() => setIsMobileMenuOpen(false)}
                className="whitespace-nowrap text-slate-700 hover:text-slate-900 text-sm font-medium cursor-pointer"
              >
                Become a Vendor
              </Link>
              <Link 
                to="/contact" 
                onClick={() => setIsMobileMenuOpen(false)}
                className="whitespace-nowrap text-slate-700 hover:text-slate-900 text-sm font-medium cursor-pointer"
              >
                Contact
              </Link>
              <Link 
                to="/login" 
                onClick={() => setIsMobileMenuOpen(false)}
                className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-6 py-2.5 bg-slate-900 text-white text-sm font-semibold rounded-lg hover:bg-slate-800 transition-colors cursor-pointer"
              >
                <i className="ri-flag-line"></i>
                Customer Login
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
